// extracted by mini-css-extract-plugin
export default {"package":"ge6fkBTo8bnFWi0dMhVV7Q=="};